import React from "react";
import { NavBar } from "./NavBar";

import { Outlet, useLocation } from "react-router-dom";


export const RouterLayout: React.FC<{}> = () => {
    const location = useLocation();
    const isChatPage = location.pathname === '/chat';

    return (
        <>

            {/* {!isChatPage && <NavBar />} */}
            <Outlet />

        </>
    );
};
